import { render, staticRenderFns } from "./ArrowExibitionButton.vue?vue&type=template&id=52660422"
import script from "./ArrowExibitionButton.vue?vue&type=script&lang=ts"
export * from "./ArrowExibitionButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports